export const iconFontAwesomeSciencefictionAtom = (
	<i className="fa-solid fa-atom"></i>
);
